import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { saveShippingAddress } from "../actions/cartActions";
import CheckoutSteps from "../components/CkeckoutSteps";

const ShippingScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;

  let [address, setAddress] = useState(shippingAddress.address);
  let [city, setCity] = useState(shippingAddress.city);
  let [postalCode, setPostalCode] = useState(shippingAddress.postalCode);
  let [tel, setTel] = useState(shippingAddress.tel);
  // eslint-disable-next-line no-unused-vars
  let [country, setCountry] = useState(shippingAddress.country);
  let [state, setState] = useState(shippingAddress.state);

  const submitHandler = (e) => {
    e.preventDefault();
    country = "México";
    dispatch(
      saveShippingAddress({ address, city, state, postalCode, tel, country })
    );
    navigate("/placeorder");
  };

  const isValid = address && city && state && postalCode && tel;

  return (
    <>
      <CheckoutSteps />
      <style>{`
        .hadacy-shipping {
          --cream: #f5efe1;
          --dark: #2a1f0c;
          --gold: #b58c2c;
          --gold-light: #d4a949;
          --muted: #8b7458;
          --card-bg: #fbf7ec;
          --recess: #ede3cf;
          --hairline: rgba(43, 31, 12, 0.12);
          max-width: 640px;
          margin: 0 auto;
          padding: 0 16px;
        }
        .hadacy-shipping__head {
          text-align: center;
          margin-bottom: 28px;
        }
        .hadacy-shipping__title {
          font-family: 'Cormorant Garamond', serif;
          font-weight: 500;
          font-size: 42px;
          color: var(--dark);
          margin: 0 0 8px;
          letter-spacing: -0.005em;
        }
        .hadacy-shipping__rule {
          width: 48px;
          height: 1px;
          background: var(--gold);
          margin: 0 auto 14px;
          border: 0;
        }
        .hadacy-shipping__lead {
          font-family: 'Jost', sans-serif;
          font-size: 13px;
          color: var(--muted);
          letter-spacing: 0.04em;
          margin: 0 auto;
          line-height: 1.6;
          max-width: 480px;
        }
        .hadacy-shipping__card {
          background: var(--card-bg);
          border: 1px solid var(--hairline);
          border-radius: 6px;
          padding: 32px;
          box-shadow: 0 2px 14px rgba(43, 31, 12, 0.06);
        }
        @media (max-width: 480px) {
          .hadacy-shipping__card { padding: 22px; }
        }
        .hadacy-shipping__card .form-group {
          margin-bottom: 18px;
        }
        .hadacy-shipping__card .form-label {
          font-family: 'Jost', sans-serif;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--muted);
          margin-bottom: 6px;
        }
        .hadacy-shipping__card .form-control {
          background: var(--cream);
          border: 1px solid var(--hairline);
          border-radius: 4px;
          padding: 12px 14px;
          font-family: 'Jost', sans-serif;
          font-size: 14px;
          color: var(--dark);
        }
        .hadacy-shipping__card .form-control:focus {
          border-color: var(--gold);
          box-shadow: 0 0 0 3px rgba(181, 140, 44, 0.15);
          background: var(--card-bg);
        }
        .hadacy-shipping__card .form-control::placeholder {
          color: var(--muted);
          opacity: 0.7;
        }
        .hadacy-shipping__card .form-control:disabled,
        .hadacy-shipping__card .form-control[readonly] {
          background: var(--recess);
          color: var(--muted);
          cursor: not-allowed;
          opacity: 0.85;
        }
        .hadacy-shipping__row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px;
        }
        @media (max-width: 480px) {
          .hadacy-shipping__row {
            grid-template-columns: 1fr;
            gap: 0;
          }
        }
        .hadacy-shipping__country-note {
          font-family: 'Jost', sans-serif;
          font-size: 12px;
          color: var(--muted);
          font-style: italic;
          margin: 4px 0 24px;
          line-height: 1.6;
          padding: 10px 14px;
          border-left: 2px solid var(--gold);
          background: rgba(181, 140, 44, 0.06);
          border-radius: 0 4px 4px 0;
        }
        .hadacy-shipping__cta {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          width: 100%;
          padding: 14px 24px;
          background: var(--dark);
          color: var(--cream);
          border: 1px solid var(--dark);
          border-radius: 999px;
          font-family: 'Jost', sans-serif;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          cursor: pointer;
          transition: background 0.2s ease, color 0.2s ease,
            border-color 0.2s ease;
        }
        .hadacy-shipping__cta:hover:not(:disabled) {
          background: var(--gold);
          border-color: var(--gold);
          color: var(--cream);
        }
        .hadacy-shipping__cta:hover:not(:disabled) i {
          transform: translateX(4px);
        }
        .hadacy-shipping__cta i { transition: transform 0.2s ease; }
        .hadacy-shipping__cta:disabled {
          background: var(--recess);
          color: var(--muted);
          border-color: var(--hairline);
          cursor: not-allowed;
        }
      `}</style>

      <div className="hadacy-shipping">
        <div className="hadacy-shipping__head">
          <h1 className="hadacy-shipping__title">Envío</h1>
          <hr className="hadacy-shipping__rule" />
          <p className="hadacy-shipping__lead">
            ¿A dónde te enviamos tu pedido?
          </p>
        </div>

        <div className="hadacy-shipping__card">
          <Form onSubmit={submitHandler}>
            <Form.Group controlId="address" className="form-group">
              <Form.Label>Dirección (calle, colonia y número)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Av. Vallarta 123, Col. Centro"
                value={address}
                required
                onChange={(e) => setAddress(e.target.value)}
              />
            </Form.Group>

            <div className="hadacy-shipping__row">
              <Form.Group controlId="city" className="form-group">
                <Form.Label>Ciudad</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Guadalajara"
                  value={city}
                  required
                  onChange={(e) => setCity(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="state" className="form-group">
                <Form.Label>Estado</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Jalisco"
                  value={state}
                  required
                  onChange={(e) => setState(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className="hadacy-shipping__row">
              <Form.Group controlId="postalCode" className="form-group">
                <Form.Label>Código postal</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="44100"
                  value={postalCode}
                  required
                  onChange={(e) => setPostalCode(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="tel" className="form-group">
                <Form.Label>Teléfono</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="33 1234 5678"
                  value={tel}
                  required
                  onChange={(e) => setTel(e.target.value.slice(0, 10))}
                />
              </Form.Group>
            </div>

            <Form.Group controlId="country" className="form-group">
              <Form.Label>País</Form.Label>
              <Form.Control type="text" value="México" disabled readOnly />
            </Form.Group>

            <p className="hadacy-shipping__country-note">
              Por el momento solo enviamos dentro de la República Mexicana. Si
              quieres comprar desde otro país, por favor contáctanos.
            </p>

            <button
              type="submit"
              className="hadacy-shipping__cta"
              disabled={!isValid}
            >
              Continuar
              <i className="fas fa-arrow-right"></i>
            </button>
          </Form>
        </div>
      </div>
    </>
  );
};

export default ShippingScreen;
